import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/icon/thumb.png'


const _withScopeId = n => (_pushScopeId("data-v-743942a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "HotSearch abs" }
const _hoisted_2 = {
  key: 0,
  class: "HotSearch-block"
}
const _hoisted_3 = { class: "HotSearch-title" }
const _hoisted_4 = { class: "HotSearch-block-list" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  class: "HotSearch-title",
  style: {"margin-top":"10px"}
}
const _hoisted_7 = { style: {"display":"inline-block"} }
const _hoisted_8 = {
  key: 0,
  class: "tiktokTag mb_10"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-cen-ter" }, [
  /*#__PURE__*/_createTextVNode(" 2024 Summer Outfits "),
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://static-s.theckb.com/BusinessMarket/Client/activity/summerOutfits/star.png",
    alt: "",
    style: {"width":"28px","margin-left":"6px"}
  })
], -1))
const _hoisted_10 = {
  key: 1,
  class: "tiktokTag"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-cen-ter" }, [
  /*#__PURE__*/_createTextVNode(" Beach Must Have 2024 "),
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://static-s.theckb.com/BusinessMarket/Client/activity/summerOutfits/star.png",
    alt: "",
    style: {"width":"28px","margin-left":"6px"}
  })
], -1))
const _hoisted_12 = {
  key: 2,
  class: "tiktokTag ml_10"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-cen-ter" }, [
  /*#__PURE__*/_createTextVNode(" Tiktok made me buy it "),
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://static-s.theckb.com/BusinessMarket/Client/activity/tiktok/logo.png",
    alt: "",
    class: "tiktok-logo"
  })
], -1))
const _hoisted_14 = {
  key: 3,
  class: "spring-hot-tag"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spring-hot-tag-container" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text" }, "2024년 봄 상품 추천"),
  /*#__PURE__*/_createElementVNode("span", { class: "tag" }, "NEW")
], -1))
const _hoisted_16 = { class: "regularTag" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_18 = { class: "HotSearch-title" }
const _hoisted_19 = {
  key: 0,
  class: "HotSearch-title-icon"
}
const _hoisted_20 = ["src"]
const _hoisted_21 = { class: "HotSearch-block-list" }
const _hoisted_22 = ["onClick"]

import { onMounted, reactive, computed } from 'vue'
import { t } from '@/plugins/i18n'
import { getHistorySearch, getHotSearch } from '@/apis/search'
import { useRequest } from '@/util/useLoading'
import { useStore } from 'vuex'
import { useRtfix, isJA, useSite2Station, isEN, isKO } from '@/store'
import { res } from '@/apis/login'
import { Site } from '@/common/const'
interface HostListItem {
  productCategoryFrontendId: string;
  keywordList: string[];
  cateNameZh: string;
  cateNameJp: string;
  cateIcon?: string;
}


export default /*#__PURE__*/_defineComponent({
  emits: ['selected', 'handleSearch'],
  setup(__props, { emit: emits }) {

const store = useStore()
const site = useSite2Station()
const buss = store.state.bussiness
const token = computed(() => store.getters.token)

const hotWord = isJA() ? t('1688国家货盘') : t('1688严选')

onMounted(() => {
  if (token.value) {
    getHistoryList()
  }

  getHotList()
})



const data: any = reactive({
  // 历史关键词列表
  historyList: [],
  // 热搜关键词列表
  hotList: []
})

// 获取历史搜索关键词
const [historyLoading, getHistoryList] = useRequest<res, { stationCode: Site }>(
  getHistorySearch,
  {
    onSuccess (res) {
      if (res.code === '0') {
        // 历史搜索最多只展示10条
        data.historyList = (res.data || []).slice(0, 10)
      }
    }
  }
)

// 获取热搜关键词
const [hotLoading, getHotList] = useRequest<
  res<HostListItem[]>,
  { stationCode: Site }
>(getHotSearch, {
  onSuccess (res) {
    if (res.code === '0') {
      // 每个分类下，最多只展示10个关键词
      data.hotList = res?.data
        ?.map?.((category) => {
          const keywordList = category.keywordList.slice(0, 10)
          return {
            ...category,
            keywordList
          }
        })
        .reverse()
    }
  }
})

// 选中关键词
const selected = (keyword: string, item?: any) => {
  if (item) {
    const cates = buss.category[buss.schannel || '0']
    const cate = cates.find((v: any) => v.cateNameZh === item.cateNameZh)
    if (cate) {
      store.commit(
        'bussiness/productCategoryFrontendId',
        cate.productCategoryFrontendId
      )
      store.commit(
        'bussiness/productCategoryFrontendIdNameZh',
        cate.cateNameZh
      )
    } else {
      store.commit('bussiness/productCategoryFrontendId', '')
      store.commit('bussiness/productCategoryFrontendIdNameZh', '')
    }
  }
  emits('selected', keyword)
}

// 选择1688
const thumbSelected = (keyword: string) => {
  if (buss.schannel === 2) {
    store.commit('bussiness/platformType', 'AM')
  }
  emits('selected', keyword)
  emits('handleSearch')
}


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(token))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)("搜索历史")), 1),
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).historyList, (keyword, index) => {
              return (_openBlock(), _createElementBlock("span", {
                key: index,
                onClick: ($event: any) => (selected(keyword))
              }, _toDisplayString(keyword), 9, _hoisted_5))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(t)("热门推荐词")), 1),
    _createElementVNode("div", _hoisted_7, [
      (_unref(isEN)())
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(_component_router_link, {
              to: _unref(useRtfix)('summerOutfits'),
              class: "tiktok"
            }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            }, 8, ["to"])
          ]))
        : _createCommentVNode("", true),
      (_unref(isEN)())
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createVNode(_component_router_link, {
              to: _unref(useRtfix)('beachMustHave'),
              class: "tiktok"
            }, {
              default: _withCtx(() => [
                _hoisted_11
              ]),
              _: 1
            }, 8, ["to"])
          ]))
        : _createCommentVNode("", true),
      (_unref(isEN)())
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createVNode(_component_router_link, {
              to: _unref(useRtfix)('tiktok'),
              class: "tiktok"
            }, {
              default: _withCtx(() => [
                _hoisted_13
              ]),
              _: 1
            }, 8, ["to"])
          ]))
        : _createCommentVNode("", true),
      (_unref(isKO)())
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createVNode(_component_router_link, {
              to: _unref(useRtfix)('springHot')
            }, {
              default: _withCtx(() => [
                _hoisted_15
              ]),
              _: 1
            }, 8, ["to"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", {
          class: "flex-cen-ter",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (thumbSelected(_unref(hotWord))))
        }, [
          _hoisted_17,
          _createTextVNode(" " + _toDisplayString(_unref(hotWord)), 1)
        ])
      ])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).hotList, (item) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "HotSearch-block",
        key: item.productCategoryFrontendId
      }, [
        _createElementVNode("div", _hoisted_18, [
          (item.cateIcon)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _createElementVNode("img", {
                  referrerPolicy: "no-referrer",
                  class: "wrap",
                  src: item.cateIcon,
                  alt: ""
                }, null, 8, _hoisted_20)
              ]))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString({
          [_unref(Site).JA]: item.cateNameJp,
          [_unref(Site).KO]: item.cateNameKr,
          [_unref(Site).EN]: item.cateNameEn,
        }[_unref(site)]), 1)
        ]),
        _createElementVNode("div", _hoisted_21, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.keywordList, (keyword) => {
            return (_openBlock(), _createElementBlock("span", {
              key: keyword,
              onClick: ($event: any) => (selected(keyword, item))
            }, _toDisplayString(keyword), 9, _hoisted_22))
          }), 128))
        ])
      ]))
    }), 128))
  ], 512)), [
    [_directive_loading, _unref(historyLoading) || _unref(hotLoading)]
  ])
}
}

})